import { RootState } from '../storeTypes';

export const getActivityDefinitionsSelector = (state: RootState) =>
  state.libraryState.activityDefinitions;
